import { rem, SystemStyleObject } from '@vimeo/bokeh';

export const LOGIN_SCREEN_WRAPPER_STYLE: SystemStyleObject = {
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  flexGrow: 1,
  flexBasis: 0,
  overflow: 'auto',
  width: '100%',
  maxWidth: rem(640),
  minHeight: rem(280),
  background: 'surface', //core.color.surface(800)?
};

export const LOGIN_CONTAINER_WRAPPER_STYLE: SystemStyleObject = {
  flexDirection: 'column',
  padding: rem(16),
  color: 'text-primary',
  maxWidth: rem(420),
  width: '100%',
  margin: 'auto',
};

export const LOGIN_CONTEXT_LABELS_STYLE: SystemStyleObject = {
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: rem(24),
  rowGap: rem(16),
};
